import { Phone, Mail, Instagram, MapPin, MessageCircle } from "lucide-react";
import { BRAND } from "../../content/site";

const ROWS = [
  { icon: Phone, label: "Call", value: BRAND.phone, href: BRAND.phoneHref, id: "phone" },
  { icon: MessageCircle, label: "WhatsApp", value: BRAND.phone, href: BRAND.whatsapp, id: "whatsapp" },
  { icon: Mail, label: "Email", value: BRAND.email, href: `mailto:${BRAND.email}`, id: "email" },
  { icon: Instagram, label: "Instagram", value: BRAND.instagram, href: BRAND.instagramUrl, id: "instagram" },
  { icon: MapPin, label: "Studio", value: BRAND.location, id: "location" },
];

export const ContactInfo = () => (
  <div className="flex h-full flex-col">
    <p className="font-script text-4xl text-gold">{BRAND.contactPerson}</p>
    <p className="mt-1 text-xs uppercase tracking-[0.25em] text-ink-soft">Founder & lead photographer</p>
    <ul className="mt-8 space-y-1">
      {ROWS.map(({ icon: Icon, label, value, href, id }) => {
        const inner = (
          <>
            <span className="grid h-11 w-11 shrink-0 place-items-center rounded-full border border-gold/30 bg-white text-gold transition-colors duration-300 group-hover:bg-gold group-hover:text-cream">
              <Icon className="h-4 w-4" />
            </span>
            <span className="min-w-0">
              <span className="block text-[11px] uppercase tracking-[0.22em] text-ink-soft">{label}</span>
              <span className="block break-words text-[13px] text-ink sm:text-[15px]">{value}</span>
            </span>
          </>
        );
        return (
          <li key={id}>
            {href ? (
              <a href={href} target={href.startsWith("http") ? "_blank" : undefined} rel="noopener noreferrer" className="group flex items-center gap-4 rounded-2xl py-2.5" data-testid={`contact-${id}`}>{inner}</a>
            ) : (
              <div className="group flex items-center gap-4 py-2.5" data-testid={`contact-${id}`}>{inner}</div>
            )}
          </li>
        );
      })}
    </ul>
    <div className="relative mt-8 min-h-[220px] flex-1 overflow-hidden rounded-[24px] border border-gold/25" data-testid="contact-map">
      <iframe title="Glow Motion Pictures location" src={BRAND.mapEmbed} loading="lazy" className="absolute inset-0 h-full w-full grayscale-[60%] sepia-[20%]" referrerPolicy="no-referrer-when-downgrade" />
    </div>
  </div>
);
